var YouLi = YouLi ? YouLi : {};
YouLi.Trip = YouLi.Trip ? YouLi.Trip : {};

(function (YouLi) {
    (function (Trip) {

        var Map = null;
        var Geocoder = null;
        YouLi.Trip.CurrentSection = "program";
        YouLi.Trip.InitialDate = "";
        YouLi.Trip.SkipToItinerary = false;
        YouLi.Trip.ShowInviteesAllTab = false;
        YouLi.Trip.ShowCompleted = false;
        YouLi.Trip.InviteeHasResponded = false;
        YouLi.Trip.IsTemplate = false;
        YouLi.Trip.ShowImageErrorReport = false;

        YouLi.Trip.PaymentStyle = "";
        YouLi.Trip.PricingMode = "";
        YouLi.Trip.CheckoutFlowPageURL = "";
        YouLi.Trip.IsAnonymousAccess = false;

        YouLi.Trip.RequireResponseLastName = false;
        YouLi.Trip.RequireConsent = false;
        YouLi.Trip.PreviousSection = "program";
        YouLi.Trip.CurrentInviteeMagicLink = "";
        YouLi.Trip.StylesNameSalesPageDrSheri = "";
        YouLi.Trip.RespondedRecently = false;
        YouLi.Trip.CheckoutSuccessfulRecently = false;
        YouLi.Trip.GangPlaceholdersDialogOnLoad = false;

        YouLi.Trip.FooterUpdatesPaused = false;
        YouLi.Trip.PaymentsListUpdateCount = 0;
        YouLi.Trip.DelaysForPaymentsListUpdate = [3000, 3000, 60000];
        YouLi.Trip.FooterUpdateTimeout = 30000;
        YouLi.Trip.StyleName = "";
        YouLi.Trip.TripHasMobileAppEnabled = false;
        YouLi.Trip.IsCurrentUserTripPlanner = false;
        YouLi.Trip.IsCurrentUserTripOwner = false;


        YouLi.Trip.EmailDomainValidationWhitelist = [];
        YouLi.Trip.EmailDomainValidationErrorText = "";

        YouLi.Trip.MainTourMagicLink = "";

        YouLi.Trip.AffixTop = () => {
            var affixTop = 54;  // allow for the sticky planner menu - no big deal if this actually could be zero

            if (YouLi.Trip.StyleName == YouLi.Trip.StylesNameSalesPageDrSheri) {
                doScroll = true;
                affixTop = 100;
            }

            return affixTop;
        };

        YouLi.Trip.StripBlankLinkTargets = function () {
            // first, add a class to any links within elements that have the exclusion class on them (this makes the removal easier)
            $('.keep-target-on-links a').addClass('keep-target-on-links');
            $('a[target="_blank"]:not(.keep-target-on-links)').removeAttr('target');
            console.log("Testing 124")
        };

        YouLi.Trip.GoToSection = function (section, element, doScroll, scrollOverride, updatePreviousSection = true) {
            // Remove trailing question mark or marks, if any.
            // This is to avoid a situation where there's a trailing question mark because of the '? cm_dontconvertlink' to stop Campaign Monitor from converting and expiring our links
            // utm_content=InviteeMagicLink#paymentdetails?
            section = section.replace(/\?+$/, '');

            // First, check that we are allowing them to even go to this section based on a few business rules
            // (e.g. for trips with Rooming Map, if the trip package room isn't selected yet, we're not showing payment details yet)
            if (section == "paymentdetails" && $(".content-tab-paymentdetails").hasClass("hidden")) {
                if ($(".content-tab-roomingmap").length > 0 && !$(".content-tab-roomingmap").hasClass("hidden")) {
                    section = "roomingmap";  // if we are NOT showing payment deatils, go to the default section
                }
                else {
                    select = "program";  // if we are NOT showing payment deatils, go to the default section
                }
            }

            // Next, check that we have this section
            if ($("#content-trip-" + section).length == 0)
                return;

            // If we are on a pre or post tour, redirect to the main tour for certain sections which have consolidated views available.
            // MainTourMagicLink is only set when viewing a pre or post tour; the startsWith check is a safeguard against
            // redirecting to the page we are already on, which would reload endlessly.
            if ((section == "paymentdetails" || section == "itinerary" || section == "tasks")
                && YouLi.Trip.MainTourMagicLink.length > 0
                && !window.location.href.startsWith(YouLi.Trip.MainTourMagicLink)) {

                YouLi.Common.UI.ShowLoading();

                window.location.href = `${YouLi.Trip.MainTourMagicLink}#${section}`;

                return;
            }

            //Google tag manager 
            if (section == "paymentdetails" && YouLi.Trip.CurrentSection != "paymentdetails") {

                if ($("#IsBooked").val() == "" || $("#IsBooked").val() == "False") {
                    var gaData = YouLi.Common.GetGAData("view_cart");
                    dataLayer.push({ ecommerce: null });
                    dataLayer.push(gaData);
                }
            }

            YouLi.Trip.CurrentSection = section;

            // update the activated menu
            $(".content-trip-details-menu .nav li").removeClass("active");
            var selectedSectionMenuItem = $(".content-trip-details-menu .nav").find("[data-section='" + section + "']");
            $(selectedSectionMenuItem).addClass("active");

            window.location.hash = section;

            // only update the previous section if either a data value has been provided and set to true, or if it hasn't been provided then base it on the function parameter
            if (($(element).data("update-previous-section") != undefined && $(element).data("update-previous-section")) || ($(element).data("update-previous-section") == undefined && updatePreviousSection)) {
                YouLi.Trip.PreviousSection = window.location.hash.substr(1);
            }

            // update the content
            $(".content-trip-inner").addClass("hidden");
            var selectedContent = $("#content-trip-" + section);
            $(selectedContent).removeClass("hidden");

            // Scroll if the source element specified to
            if ($(element).data("scroll") == true || doScroll) {
                // scroll the top of the content into view, or to a specific element based on the scrollOverride
                let scrollTarget = $(selectedContent);
                if ($(element).data("scroll-override") || scrollOverride) {
                    var scrollOverrideTargetName = $(element).data("scroll-override") || scrollOverride;
                    scrollTarget = $(scrollOverrideTargetName);
                }

                $('html, body').animate({
                    scrollTop: scrollTarget.offset().top - YouLi.Trip.AffixTop()
                }, 1000);
            }

            // run initialise on certain tabs as required
            if (section == "itinerary") {
                YouLi.Trip.Itinerary.FilterItems();
                YouLi.Trip.Itinerary.UpdateMenuNav();
            }
            else if (section == "program") {
                YouLi.Trip.Program.RefreshLayout();
                YouLi.Trip.Program.UpdateMenuNav();
            }
            else if (section == "roomingmap") {
                YouLi.Trip.RoomingMap.ClearZoom();
            }
            else if (section == "paymentdetails") {
                YouLi.Trip.Payments.CheckForPaymentButtonUpdate();
            }
        }

        YouLi.Trip.ExpressInterestFormSuccess = function (result) {
            YouLi.Trip.Program.SaveDone = true; // set this in case we have that flow happening

            var formSubmitBtn = $("form").find("input[type='submit']");

            if (result.errors) {
                YouLi.Common.UI.HideInputLoading(formSubmitBtn);
                YouLi.Common.UI.HideLoading();
                YouLi.Common.UI.ClearClientSideErrors();
                YouLi.Common.UI.FormatClientSideErrors(result.errors);

            } else {
                YouLi.Common.UI.ClearClientSideErrors();
                if (result.url) {
                    window.location.href = result.url;
                    if (result.reload)
                        location.reload();
                } else {
                    YouLi.Common.UI.HideInputLoading(formSubmitBtn);
                    YouLi.Common.UI.HideLoading();
                }
            }
        };

        YouLi.Trip.ExpressInterestFormFailure = function (xhr, status, error) {
            var formSubmitBtn = $("form").find("input[type='submit']");
            YouLi.Common.UI.HideInputLoading(formSubmitBtn);

            YouLi.Common.UI.FormatClientSideErrors(error, xhr);

            $('#ResponseDialogYes').animate({ scrollTop: 0 }, 800);
        };

        YouLi.Trip.GoToInviteeSection = function (section) {

            // update the activated menu
            $(".invitees-section-links .content-list-tab").removeClass("active");
            var selectedSectionMenuItem = $(".invitees-section-links").find("[data-section='" + section + "']");
            $(selectedSectionMenuItem).addClass("active");

            // update the content
            $(".invitees-list-main").addClass("hidden");
            var selectedContent = $("#invitees-section-" + section + ".invitees-list-main");
            $(selectedContent).removeClass("hidden");

        }

        YouLi.Trip.GoToResourceSection = function (section) {

            // update the activated menu
            $(".resources-section-links .content-list-tab").removeClass("active");
            var selectedSectionMenuItem = $(".resources-section-links").find("[data-section='" + section + "']");
            $(selectedSectionMenuItem).addClass("active");

            // update the content
            $(".resources-list-main").addClass("hidden");
            var selectedContent = $("#resources-section-" + section + ".resources-list-main");
            $(selectedContent).removeClass("hidden");

        }

        YouLi.Trip.UpdateCurrentInviteeName = function (name) {
            $('.invitees-list ul li[data-current-invitee="true"]').find(".name").html(name);
            $('.title-bar').find(".name").html(name);
        }

        YouLi.Trip.UpdateCurrentInviteeMiniBio = function (minibio) {
            $('.invitees-list ul li[data-current-invitee="true"]').find(".bio").html(minibio);
            $('.title-bar').find(".bio").html(minibio);
            $('.title-bar').find(".bio").data('content', minibio);
            YouLi.Trip.TrimMiniBioDisplay();

        }

        YouLi.Trip.UpdateCurrentInviteeAvatar = function (avatarURL) {
            $('.invitees-list ul li[data-current-invitee="true"]').find("img").attr("src", avatarURL);
            $('.title-bar').find("img").attr("src", avatarURL);
        }

        YouLi.Trip.SetupMapEvents = function () {
            $(document).off("click", "#TripLocationMapStatic");
            $(document).on("click", "#TripLocationMapStatic", function () {

                var script = document.createElement("script");
                script.setAttribute("src", "https://maps.googleapis.com/maps/api/js?key=AIzaSyCxwsk9jvdqzM9JSUbRhYfJiptxIAlDGCk&v=3&callback=YouLi.Trip.Maps.SetupLocationMap&loading=async");
                script.setAttribute("defer", "");
                document.getElementById("MapScripts").append(script);

                // unbind this event again (just in case the this setup function gets run again)
                $(document).off("click", "#TripLocationMapStatic");
            });
        }

        YouLi.Trip.AddTripToCalendar = function (element, calendarType) {
            let event = {
                title: $("#TripName").val(),
                start: new Date($("#TripStartDateTimeUTC").val() + "Z"),
                end: new Date($("#TripEndDateTimeUTC").val() + "Z"),
                address: $("#TripPrimaryLocation").val(),
                description: "Please be sure to complete any tasks before the event and check for updates on schedule: " + YouLi.Trip.CurrentInviteeMagicLink
            };
            YouLi.Trip.AddToCalendar(element, calendarType, event);
            return false;
        };

        YouLi.Trip.AddToCalendar = function (element, calendarType, event) {
            const forbiddenChars = /[^a-zA-Z0-9 -!\.,:;\|^$()\/\\]/;
            event.title = event.title.replace(forbiddenChars, '');

            const calLink = getAddToCalendarURL({ data: event, type: calendarType });
            if (calLink) {
                $(element).attr("href", calLink);
                $(element).attr("onclick", ""); // clear out this click event now we've worked out the proper link
                $(element).click();
                return false;
            }
            else {
                console.error("YouLi.Trip.AddToCalendar: Invalid event");
                return false;
            }

            return false;
        }

        YouLi.Trip.AdjustFooterForFloatingFooter = function () {

            $(".footer").css("margin-bottom", $(".content-trip-response-footer").outerHeight())

        }

        YouLi.Trip.UpdateResponseFooter = function (runOnce, checkTripUpdates) {

            // Only update the footer if we're not already alerting them to the need to refresh. If we're already alerting them to push, we don't
            // need to check again for footer updates
            if ($("#ShowingRefreshMessage").val() == "true")
                return;

            // If the page isn't currently active (and is not a run-once forced update), we want to pause the update, and just set a new timeout to check again.  
            // DEV NOTE: in Chrome (and probably other browsers), having focus on the DevTools window WILL take focus away from the document
            if (!runOnce && !document.hasFocus()) {
                setTimeout(function () {
                    YouLi.Trip.UpdateResponseFooter(false, true);
                }, YouLi.Trip.FooterUpdateTimeout);

                return;
            }

            var tripId = $("#TripId").val();
            var inviteeId = $("#InviteeId").val();
            var previewMode = $("#PreviewMode").val();
            var lastTripItemUpdateDate = $("#LastTripItemUpdateDate").val();

            var updateUrl = '/trip/updateresponsefooter?tripid=' + tripId + "&inviteeid=" + inviteeId + "&preview=" + previewMode
            if (checkTripUpdates)
                updateUrl += "&lastUpdateTime=" + lastTripItemUpdateDate;

            YouLi.Common.Get({
                url: updateUrl,
                suppressLoading: true,
            }).then(function (response) {
                if (!YouLi.Trip.FooterUpdatesPaused) {
                    $("#ResponseFooter").html(response);
                    YouLi.Trip.AdjustFooterForFloatingFooter();
                }
            });
        }

        YouLi.Trip.SetupUpdatePaymentsListTimer = function () {
            YouLi.Trip.PaymentsListUpdateCount = 0;
            if ($(".cost-line-item-paid.in-progress").length > 0) {
                setTimeout(function () {
                    YouLi.Trip.RefreshPaymentsList();
                }, YouLi.Trip.DelaysForPaymentsListUpdate[YouLi.Trip.PaymentsListUpdateCount]);
            }
        };

        YouLi.Trip.RefreshPaymentsList = function () {

            var tripId = $("#TripId").val();
            var inviteeId = $("#InviteeId").val();
            var previewMode = $("#PreviewMode").val();

            var updateUrl = '/trip/updatepaymentslist?tripid=' + tripId + "&inviteeid=" + inviteeId + "&preview=" + previewMode

            YouLi.Common.Get({
                url: updateUrl,
                suppressLoading: true,
            }).then(function (response) {

                YouLi.Trip.PaymentsListUpdateCount++;

                $("#ContentCostPaymentList").html(response.costPaymentsListHtml);

                if (response.contentCostPaymentDetailsHtml && $(".content-trip-paymentdetails-costs").length > 0) {
                    $(".content-trip-paymentdetails-costs").html(response.contentCostPaymentDetailsHtml);
                    YouLi.Trip.Payments.RefreshPaymentMethod(true);
                }
                else {
                    if ($(".cost-installments-selection:not(.individual)").length > 0) {
                        $(".cost-installments-selection:not(.individual)").html(response.installmentsTableHtml);
                    }

                    $("#ContentCostPaymentMethods").html(response.costPaymentMethodsHtml);
                    YouLi.Trip.Payments.RefreshPaymentMethod(true);

                    $('#SavedPaymentMethodConfirmationContainer').html(response.savedPaymentDialogHtml);
                }

                if ($(".cost-line-item-paid.in-progress").length > 0 && YouLi.Trip.PaymentsListUpdateCount < YouLi.Trip.DelaysForPaymentsListUpdate.length) {
                    setTimeout(function () {
                        YouLi.Trip.RefreshPaymentsList();
                    }, YouLi.Trip.DelaysForPaymentsListUpdate[YouLi.Trip.PaymentsListUpdateCount]);
                }
            });
        }

        YouLi.Trip.AffixWindowResizeInitialised = false;

        YouLi.Trip.TrimMiniBioDisplay = function () {

            let bio = $('.mini-bio').data('content');
            let bioLength = window.innerWidth < 768 ? 50 : 200;
            bio = YouLi.Common.Utils.TrimToSize(bio, bioLength, true);
            $('.mini-bio').html(bio);
        };

        YouLi.Trip.SetupFixNavbarOnTop = function () {
            // set up scroll behaviour for the dr-sheri sales page
            if (!($('.anonymous').length) && YouLi.Trip.StyleName == YouLi.Trip.StylesNameSalesPageDrSheri) {
                $(window).off("scroll");
                if (window.innerWidth <= 767) {
                    YouLi.Trip.FixNavbarOnTop();
                    $(window).on("scroll", function () {
                        YouLi.Trip.FixNavbarOnTop();
                    });
                }
                else
                    $('.content-trip-details-top').css("top", 54)
            }
        };

        YouLi.Trip.FixNavbarOnTop = function () {
            if (window.pageYOffset > 55) {
                $('.content-trip-details-top').css("top", "55px");
            } else {
                $('.content-trip-details-top').css("top", "96px");;
            }
        };

        YouLi.Trip.ToggleMainMenu = function () {
            if ($('.content-trip-details-menu').find('li:not(.hidden)').length == 2) {
                $('.content-trip-details-menu').addClass('hidden');
            }
            if ($('.content-trip-details-menu-top').find('li:not(.hidden):not(.sign-up-btn)').length == 2) {
                $('.content-trip-details-menu-top').addClass('hidden');
                $('.content-trip-heading-image').css('margin-top', '0px');
            }
        };

        YouLi.Trip.SetupInviteeSectionMenu = function () {
            // invitees menu functionality
            $(".invitees-section-links .content-list-tab:not(.disabled)").off("click touchstart").on("click touchstart", function () {
                var section = $(this).data("section");

                YouLi.Trip.GoToInviteeSection(section);
            });
        };

        YouLi.Trip.UpdateDateTimeAnswer = function (element) {
            var container = element.closest(".date-time-container");
            var datePicker = $('.datepicker', container).data("DateTimePicker");
            var timePicker = $('.timepicker', container).data("DateTimePicker");
            if (!datePicker || datePicker.date() == null || !timePicker || timePicker.date() == null) {
                $(".combined-date-time-answer", container).val("");
            }
            else {
                $(".combined-date-time-answer", container).val(
                    datePicker.date().format("D/M/Y ") + timePicker.date().format("hh:mm A"));
            }
        };

        YouLi.Trip.ViewProfileForInvitee = function (inviteeId, doScroll = false) {
            const tripId = $("#TripId").val();
            const previewMode = $("#PreviewMode").val();

            var data = {
                tripid: tripId,
                inviteeId: inviteeId,
                preview: previewMode
            };

            YouLi.Common.Post({
                url: '/Trip/ViewProfile',
                params: data,
            }).then(function (response) {
                if (response.url) {
                    window.location.href = response.url;
                }
                else if (response.success === false) {
                    YouLi.Common.UI.ShowStandardDialog("An error occurred when loading profile.");
                }
                else {
                    $("#view-profile-content").html(response);
                    YouLi.Trip.GoToSection("viewprofile", undefined, doScroll, false, false);
                }
            });
        }

        YouLi.Trip.ShowRequestMeetingBookingDialog = function (element) {
            const itemContainer = $(element).closest(".item-container");
            const meetingBlockId = $(itemContainer).data("id");
            const profileContainer = $(element).closest("#content-trip-viewprofile");
            const recipientInviteeId = $(profileContainer).data("profile-invitee-id");
            const slotBookingName = $(".view-profile-name").text();

            $("#MeetingBookingRequestDialog #RequestMeetingBlockId").val(meetingBlockId);
            $("#MeetingBookingRequestDialog #RequestMeetingRecipientInviteeId").val(recipientInviteeId);
            $("#MeetingBookingRequestDialog .invitee-name").text(slotBookingName);

            $("#MeetingBookingRequestDialog").modal("show");
        };

        YouLi.Trip.RequestMeetingBooking = function () {

            var $form = $('#RequestMeetingBlockForm');

            $.validator.unobtrusive.parse($form);
            $form.validate();

            if (!$form.valid()) {
                return;
            }

            $("#MeetingBookingRequestDialog").modal("hide");

            const customMessageElement = $("#MeetingBookingRequestDialog #CustomMessageText");

            const meetingBlockId = $("#MeetingBookingRequestDialog #RequestMeetingBlockId").val();
            const recipientInviteeId = $("#MeetingBookingRequestDialog #RequestMeetingRecipientInviteeId").val();
            const customMessageText = customMessageElement.val();

            const itineraryTabIsHidden = $("#content-trip-itinerary").hasClass("hidden");
            const inviteesTabIsHidden = $("#content-trip-invitees").hasClass("hidden");

            const itemContainer = $(`.profile-meeting-block.item-container[data-id='${meetingBlockId}']`);

            var data = {
                scheduleItemId: meetingBlockId,
                recipientInviteeId: recipientInviteeId,
                customMessageText: customMessageText
            };

            YouLi.Common.Post({
                url: '/trip/requestmeetingbooking',
                params: data,
            }).then(function (response) {
                if (response.url) {
                    window.location.href = response.url;
                }
                else if (response.success === false) {
                    var errorMessage = response.errorMessage || "An error occurred.";
                    YouLi.Common.UI.ShowStandardDialog(errorMessage, "Error");
                }
                else {
                    $(itemContainer).html(response.meetingBlockHtml);

                    YouLi.Trip.UpdateItineraryContent(itineraryTabIsHidden, response.contentItineraryHtml);
                    YouLi.Trip.UpdateInviteesContent(inviteesTabIsHidden, response.inviteesDetailsHtmlString);

                    customMessageElement.val("");
                }
            });
        }

        YouLi.Trip.ShowDeclineMeetingRequestDialog = function (element) {
            const itemContainer = $(element).closest(".item-container");
            const meetingBlockId = $(itemContainer).data("id");
            const profileContainer = $(element).closest("#content-trip-viewprofile");
            const recipientInviteeId = $(profileContainer).data("profile-invitee-id");
            const slotBookingName = $(".view-profile-name").text();

            $("#DeclineMeetingRequestDialog #RequestMeetingBlockId").val(meetingBlockId);
            $("#DeclineMeetingRequestDialog #RequestMeetingRecipientInviteeId").val(recipientInviteeId);
            $("#DeclineMeetingRequestDialog .invitee-name").text(slotBookingName);

            $("#DeclineMeetingRequestDialog").modal("show");
        };

        YouLi.Trip.DeclineMeetingRequest = function () {

            var $form = $('#DeclineRequestForm');

            $.validator.unobtrusive.parse($form);
            $form.validate();

            if (!$form.valid()) {
                return;
            }

            $("#DeclineMeetingRequestDialog").modal("hide");

            const meetingBlockId = $("#DeclineMeetingRequestDialog #RequestMeetingBlockId").val();
            const recipientInviteeId = $("#DeclineMeetingRequestDialog #RequestMeetingRecipientInviteeId").val();
            const customMessageText = $("#DeclineMeetingRequestDialog #CustomMessageText").val();

            const itineraryTabIsHidden = $("#content-trip-itinerary").hasClass("hidden");
            const inviteesTabIsHidden = $("#content-trip-invitees").hasClass("hidden");

            const itemContainer = $(`.profile-meeting-block.item-container[data-id='${meetingBlockId}']`);

            var data = {
                scheduleItemId: meetingBlockId,
                recipientInviteeId: recipientInviteeId,
                customMessageText: customMessageText
            };

            YouLi.Common.Post({
                url: '/trip/DeclineMeetingRequest',
                params: data,
            }).then(function (response) {
                if (response.url) {
                    window.location.href = response.url;
                }
                else if (response.success === false) {
                    var errorMessage = response.errorMessage || "An error occurred.";
                    YouLi.Common.UI.ShowStandardDialog(errorMessage, "Error");
                }
                else {
                    $(itemContainer).html(response.meetingBlockHtml);

                    YouLi.Trip.UpdateItineraryContent(itineraryTabIsHidden, response.contentItineraryHtml);
                    YouLi.Trip.UpdateInviteesContent(inviteesTabIsHidden, response.inviteesDetailsHtmlString);
                }
            });
        }

        YouLi.Trip.UndoDeclinedMeetingRequest = function (element) {

            const itemContainer = $(element).closest(".item-container");
            const meetingBlockId = $(itemContainer).data("id");
            const profileContainer = $(element).closest("#content-trip-viewprofile");
            const recipientInviteeId = $(profileContainer).data("profile-invitee-id");

            const itineraryTabIsHidden = $("#content-trip-itinerary").hasClass("hidden");
            const inviteesTabIsHidden = $("#content-trip-invitees").hasClass("hidden");

            var data = {
                scheduleItemId: meetingBlockId,
                recipientInviteeId: recipientInviteeId
            };

            const undoButton = $(".undo-declined-request");
            YouLi.Common.UI.ShowButtonLoading(undoButton);

            YouLi.Common.Post({
                url: '/trip/UndoDeclinedMeetingRequest',
                params: data,
                suppressLoading: true,
                errorCallback: function () {
                    YouLi.Common.UI.HideButtonLoading(undoButton);
                    YouLi.Common.UI.ShowStandardDialog("An error occurred.", "Error");
                }
            }).then(function (response) {
                YouLi.Common.UI.HideButtonLoading(undoButton);

                if (response.url) {
                    window.location.href = response.url;
                }
                else if (response.success === false) {
                    var errorMessage = response.errorMessage || "An error occurred.";
                    YouLi.Common.UI.ShowStandardDialog(errorMessage, "Error");
                }
                else {
                    $(itemContainer).html(response.meetingBlockHtml);

                    YouLi.Trip.UpdateItineraryContent(itineraryTabIsHidden, response.contentItineraryHtml);
                    YouLi.Trip.UpdateInviteesContent(inviteesTabIsHidden, response.inviteesDetailsHtmlString);
                }

            });
        }

        YouLi.Trip.ShowScheduleMeetingBookingSlot = function (element) {
            const displayTime = $(element).text();
            const slotId = $(element).data("slot-id");

            $(".meeting-block-slots--selectable").addClass("hidden");   // TODO: animate??
            const meetingBlockSelectorElement = $(element).closest(".meeting-block-slot-selector");
            $(meetingBlockSelectorElement).find(".meeting-block-slots--list--slot").find("#MeetingBlockSlotScheduleSlotDisplay").html(displayTime);
            $(meetingBlockSelectorElement).find(".meeting-block-slots--list--slot").find(".schedule-meeting").data("slot-id", slotId);
            $(meetingBlockSelectorElement).find(".meeting-block-slots--list--slot").removeClass("hidden");
        }

        YouLi.Trip.HideScheduleMeetingBookingSlot = function (element) {
            (element).closest(".meeting-block-slots--list--slot").addClass("hidden");
            $(".meeting-block-slots--selectable").removeClass("hidden");   // TODO: animate??
        }

        YouLi.Trip.ShowEditMeetingBookingSlot = function (element) {
            $(element).closest(".actions").addClass("hidden");

            // hide/show appropriate buttons for the initial stage of this flow
            const slotDetailsElement = $(element).closest(".slot-details")
            const editActionsElement = $(slotDetailsElement).find(".edit-actions");
            $(editActionsElement).find(".cancel-meeting").removeClass("hidden");
            $(editActionsElement).find(".reschedule-meeting").removeClass("hidden");
            $(editActionsElement).find(".keep-meeting").addClass("hidden");

            $(editActionsElement).find(".reschedule-meeting").off("click");
            $(editActionsElement).find(".reschedule-meeting").on("click", function () {
                YouLi.Trip.ShowRescheduleMeetingBookingSlot($(this));
            });

            $(editActionsElement).find(".cancel-meeting").off("click");
            $(editActionsElement).find(".cancel-meeting").on("click", function () {
                YouLi.Trip.ShowCancelMeetingBookingSlotDialog($(this));
            });

            $(editActionsElement).removeClass("hidden");
        }

        YouLi.Trip.ShowRescheduleMeetingBookingSlot = function (element) {
            const slotContainerElement = $(element).closest(".meeting-block-slots--list--slot-container");
            const editActionsElement = $(element).closest(".edit-actions");
            const reschedulerElement = $(slotContainerElement).find(".reschedule-selector");

            const meetingBlockBookingId = $(element).closest(".actions").data("booking-id");

            YouLi.Common.Get({
                url: '/trip/getmeetingblockrescheduler',
                params: {
                    meetingBlockBookingId: meetingBlockBookingId
                },
            }).then(function (response) {
                if (response.url) {
                    window.location.href = response.url;
                }
                else if (response.success === false) {
                    var errorMessage = response.errorMessage || "An error occurred.";
                    YouLi.Common.UI.ShowStandardDialog(errorMessage, "Error");
                }
                else {
                    $(reschedulerElement).html(response.meetingBlockReschedulerHtml);

                    $(editActionsElement).find(".cancel-meeting").addClass("hidden");
                    $(editActionsElement).find(".reschedule-meeting").addClass("hidden");
                    $(editActionsElement).find(".keep-meeting").removeClass("hidden");

                    $(editActionsElement).find(".keep-meeting").off("click");
                    $(editActionsElement).find(".keep-meeting").on("click", function () {
                        YouLi.Trip.HideEditMeetingBookingSlot($(this));
                    });

                    $(reschedulerElement).removeClass("hidden");
                    $(".meeting-block-slots--selectable").removeClass("hidden");
                }
            });
        }

        YouLi.Trip.HideEditMeetingBookingSlot = function (element) {
            $(element).closest(".slot-details").find(".actions").removeClass("hidden");
            $(element).closest(".slot-details").find(".edit-actions").addClass("hidden");

            $(element).closest(".meeting-block-slots--list--slot-container").find(".reschedule-selector").html("").addClass("hidden");
        }

        YouLi.Trip.ShowCancelMeetingBookingSlotDialog = function (cancelMeetingButtonElement) {
            const meetingBlockBookingId = $(cancelMeetingButtonElement).closest(".actions").data("booking-id");
            const slotBookingName = $(cancelMeetingButtonElement).closest(".actions").data("booking-name-other");
            const slotDisplayTime = $(cancelMeetingButtonElement).closest(".slot-details").find(".slot-display-time").text();

            $("#MeetingBookingCancelDialog #CancelMeetingBlockBookingId").val(meetingBlockBookingId);
            $("#MeetingBookingCancelDialog .meeting-block-name").text(slotDisplayTime);
            $("#MeetingBookingCancelDialog .invitee-name").text(slotBookingName);

            $("#MeetingBookingCancelDialog .do-cancel-meeting").off("click");
            $("#MeetingBookingCancelDialog .do-cancel-meeting").on("click", function () {
                YouLi.Trip.CancelMeetingBookingSlot();
            });

            $("#MeetingBookingCancelDialog").modal("show");
        }

        YouLi.Trip.CancelMeetingBookingSlot = function () {

            $("#MeetingBookingCancelDialog").modal("hide");

            const meetingBlockBookingId = $("#MeetingBookingCancelDialog #CancelMeetingBlockBookingId").val();

            let itineraryTabIsHidden = $("#content-trip-itinerary").hasClass("hidden");
            let inviteesTabIsHidden = $("#content-trip-invitees").hasClass("hidden");

            if (meetingBlockBookingId) {

                var data = {
                    meetingBlockBookingId: meetingBlockBookingId,
                };

                YouLi.Common.Post({
                    url: '/trip/cancelmeetingbooking',
                    params: data,
                }).then(function (response) {
                    if (response.url) {
                        window.location.href = response.url;
                    }
                    else if (response.success === false) {
                        var errorMessage = response.errorMessage || "An error occurred.";
                        YouLi.Common.UI.ShowStandardDialog(errorMessage, "Error");
                    }
                    else {
                        YouLi.Trip.UpdateItineraryContent(itineraryTabIsHidden, response.contentItineraryHtml);
                        YouLi.Trip.UpdateInviteesContent(inviteesTabIsHidden, response.inviteesDetailsHtmlString);

                        if ($('#content-trip-viewprofile').length > 0 && !$("#content-trip-viewprofile").hasClass("hidden")) {
                            var viewedProfileId = $("#content-trip-viewprofile").data("profile-invitee-id");
                            YouLi.Trip.ViewProfileForInvitee(viewedProfileId);
                        }
                    }
                });
            }
        }

        YouLi.Trip.SetMeetingBookingSlotAvailability = function (element) {

            var scheduleItemId = element.dataset.scheduleItemId;
            var slotId = element.dataset.slotId;
            var status = element.dataset.status;
            var meetingBlockId = element.dataset.meetingBlockBookingId;

            let itineraryTabIsHidden = $("#content-trip-itinerary").hasClass("hidden");

            var data = {
                ScheduleItemId: scheduleItemId,
                SlotId: slotId,
                Status: status,
                MeetingBlockBookingId: meetingBlockId
            };

            YouLi.Common.Post({
                url: '/trip/SetMeetingBookingAvailability',
                params: data,
            }).then(function (response) {
                if (response.url) {
                    window.location.href = response.url;
                }
                else if (response.success === false) {
                    var errorMessage = response.errors || "An error occurred.";
                    YouLi.Common.UI.ShowStandardDialog(errorMessage, "Error");
                }
                else {
                    YouLi.Trip.UpdateItineraryContent(itineraryTabIsHidden, response.contentItineraryHtml);

                    if ($('#content-trip-viewprofile').length > 0 && !$("#content-trip-viewprofile").hasClass("hidden")) {
                        var viewedProfileId = $("#content-trip-viewprofile").data("profile-invitee-id");
                        YouLi.Trip.ViewProfileForInvitee(viewedProfileId);
                    }
                }
            });
        }

        YouLi.Trip.ScheduleMeetingBookingSlot = function (scheduleMeetingButtonElement) {

            const itemContainer = $(scheduleMeetingButtonElement).closest(".item-container");
            const meetingBlockId = $(itemContainer).data("id");
            const meetingBlockBookingId = $(scheduleMeetingButtonElement).data("booking-id");
            const slotId = $(scheduleMeetingButtonElement).data("slot-id");

            let itineraryTabIsHidden = $("#content-trip-itinerary").hasClass("hidden");
            let inviteesTabIsHidden = $("#content-trip-invitees").hasClass("hidden");

            if (!(slotId && meetingBlockBookingId)) {
                return;
            }

            var data = {
                scheduleItemId: meetingBlockId,
                meetingBlockBookingId: meetingBlockBookingId,
                slotId: slotId
            };

            YouLi.Common.Post({
                url: '/trip/schedulemeetingbookingslot',
                params: data,
            }).then(function (response) {
                if (response.url) {
                    window.location.href = response.url;
                }
                else if (response.success === false) {
                    var errorMessage = response.errorMessage || "An error occurred.";
                    YouLi.Common.UI.ShowStandardDialog(errorMessage, "Error");
                }
                else {
                    YouLi.Trip.UpdateItineraryContent(itineraryTabIsHidden, response.contentItineraryHtml);
                    YouLi.Trip.UpdateInviteesContent(inviteesTabIsHidden, response.inviteesDetailsHtmlString);

                    if ($('#content-trip-viewprofile').length > 0 && !$("#content-trip-viewprofile").hasClass("hidden")) {
                        var viewedProfileId = $("#content-trip-viewprofile").data("profile-invitee-id");
                        YouLi.Trip.ViewProfileForInvitee(viewedProfileId);
                    }
                }
            });
        };

        YouLi.Trip.UpdateItineraryContent = function (itineraryTabIsHidden, html) {
            // get and restore collapsible panel states 
            var openPanelIds = $("#itinerary-content .panel-collapse.collapse.in").map(function () { return this.id; }).get();
            $('#itinerary-content').html(html);
            $(".panel-collapse.collapse").removeClass("in");
            if (openPanelIds.length > 0) {
                $('#' + openPanelIds.join(',#')).addClass("in"); // do this before calling collapse() as we don't want this animated here
                $('#' + openPanelIds.join(',#')).collapse("show");
            }

            if (!itineraryTabIsHidden)
                $("#content-trip-itinerary").removeClass("hidden");

            YouLi.Trip.Itinerary.FilterItems();
            YouLi.Trip.Itinerary.UpdateMenuNav();
        }

        YouLi.Trip.UpdateTaskContent = function (taskTabIsHidden, html) {
            $('#tasks-content').html(html);

            if (!taskTabIsHidden)
                $("#content-trip-tasks").removeClass("hidden");

            YouLi.Trip.Tasks.FilterTasks();
        }

        YouLi.Trip.UpdateProgramContent = function (programTabIsHidden, html) {

            $('#program-content').html(html);

            $("#content-trip-program").toggleClass("hidden", programTabIsHidden);

            YouLi.Trip.Program.RefreshLayout();
            YouLi.Trip.Program.UpdateMenuNav();
        }

        YouLi.Trip.UpdateInviteesContent = function (inviteeTabIsHidden, html) {

            $('#invitees-content').html(html);

            if (!inviteeTabIsHidden)
                $("#content-trip-itinerary").removeClass("hidden");

            YouLi.Trip.SetupInviteeSectionMenu();
        }

        YouLi.Trip.UpdateMenuContent = function (selectedSectionMenuItem, html) {

            // update either the "top" menu or the normal one, depending on which is in use
            if ($(".content-trip-details-menu-top").length > 0)
                $(".content-trip-details-menu-top").html(html);
            else
                $(".content-trip-details-menu").html(html);

            // update the activated menu back to what it was
            $(".content-trip-details-menu .nav li").removeClass("active");
            $(".content-trip-details-menu .nav li").find("[data-section='" + selectedSectionMenuItem + "']").addClass("active");

            YouLi.Trip.RefreshMenuAffix();
        }

        YouLi.Trip.ResizeSalesPageMenuWithLogo = function () {

            if ($("#SalesPageMenuWithLogo").length == 0)
                return;

            const menuItemLinks = $(".sales-page-dr-sheri .content-trip-details-top .content-trip-details-menu-top.traveller ul.nav a");

            if (YouLi.Common.UI.GetClientWidth() > 767) {
                $("svg", menuItemLinks).css({ "display": 'block' })
                $(".text", menuItemLinks).css({ "display": "block" })

                let firstLi = $("#SalesPageMenuWithLogo li:first-child");
                if ($(firstLi).position().top > 0) {
                    $("svg", menuItemLinks).css({ "display": "none" });

                    // If the menu STILL runs onto a second line (checking top again now), revert to the icons as well
                    if ($(firstLi).position().top > 0 && $(menuItemLinks).find("svg").first().css('display') == 'none') {
                        $(".text", menuItemLinks).css({ "display": "none" });
                        $("svg", menuItemLinks).css({ "display": 'block' })
                    }
                }

            } else {
                $(".text", menuItemLinks).css({ "display": "none" })
                $("svg", menuItemLinks).css({ "display": 'block' })
            }

            YouLi.Trip.SyncSalesPageMenuSpacerHeight();

        };

        YouLi.Trip.SyncSalesPageMenuSpacerHeight = function () {
            const menuHeightCss = $('.content-trip-details-menu-top').css('height');
            const parsedMenuHeight = parseInt(menuHeightCss, 10);

            //fallback height to 100px if somehow parsing failed
            const menuHeight = Number.isFinite(parsedMenuHeight) ? parsedMenuHeight : 100;
            $('.sales-page-menu-spacer').height(menuHeight);
        };

        YouLi.Trip.RefreshMenuAffix = function () {
            $('.content-trip-details-menu.traveller ul.nav').affix({
                offset: {
                    top: function () {
                        return $(".content-trip-details-menu").offset().top;
                    },
                    bottom: $("html").outerWidth() < 767 ? 0 : 1000
                }
            }).on("affixed.bs.affix", function () {

                if (!YouLi.Trip.AffixWindowResizeInitialised) {

                    $(window).on("resize", function () {
                        $('.content-trip-details-menu.traveller ul.nav').data('bs.affix').options.offset.bottom = $("html").outerWidth() < 767 ? 0 : 1000;
                    });
                    YouLi.Trip.AffixWindowResizeInitialised = true;
                }
            });
        }

        $(function () {

            if (YouLi.Trip.StyleName == YouLi.Trip.StylesNameSalesPageDrSheri) {
                $("#SalesPageMenuLogo img").on("load", function () {
                    YouLi.Trip.ResizeSalesPageMenuWithLogo(); // call initially after loading the logo
                });

                $(window).on("resize", function () {
                    YouLi.Trip.ResizeSalesPageMenuWithLogo();
                });
            }

            YouLi.Trip.ToggleMainMenu();

            if (YouLi.Trip.StyleName === YouLi.Trip.StylesNameSalesPageDrSheri) {
                YouLi.Trip.SyncSalesPageMenuSpacerHeight();
            }

            function ShowRespondedYesRecentlyDialog() {
                if ($("#RespondedYesRecentlyDialog").length == 1) {
                    $("#RespondedYesRecentlyDialog").modal('show');
                }
            }

            $(".load-in-app").toggle(!(YouLi.Common.Utils.IsYouLiMobileApp() || YouLi.Common.Utils.IsYouLiBundler()));        // YOULI-5601 hide Load In App button in the actual app

            $(document).off("click", ".load-in-app").on("click", ".load-in-app", function () {
                if (YouLi.Trip.OwnerHasWhiteLabelAppLaunched) {
                    $("#MobileAppWhiteLabelDialog").modal("show");
                    return false;
                }
                else if (YouLi.Trip.TripHasMobileAppEnabled) {
                    if (YouLi.Common.Utils.IsMobile() && !YouLi.Common.Utils.IsYouLiBundler()) {
                        return true;
                    }
                    else {
                        $("#MobileAppDesktopDialog").modal("show");
                        return false;
                    }
                }
                return false;
            });

            YouLi.Trip.SetupFixNavbarOnTop();
            YouLi.Trip.TrimMiniBioDisplay();

            $(window).resize(function () {
                YouLi.Trip.SetupFixNavbarOnTop();
                YouLi.Trip.TrimMiniBioDisplay();
            });

            $(document).on("click", ".share-trip-button", function () {
                var tripId = $(this).data('trip-id');
                var inviteeId = $(this).data('invitee-id');
                let userAffiliateCode = $(this).data("affiliate-code");
                const triggerPage = $(this).data("trigger-page");

                let url = `/Planner/GetTripShareView?tripId=${tripId}&inviteeId=${inviteeId}&triggerPage=${triggerPage}&userAffiliateCode=${userAffiliateCode}`;
                YouLi.Common.Get({
                    url: url,
                }).then(function (response) {
                    $("#share-trip-div").html(response);
                    $('#ShareTripDialog').modal("show");
                });
            });

            YouLi.Trip.Program.UpdateMenuNav(); // init

            if ((YouLi.Common.Utils.IsYouLiMobileApp() || YouLi.Common.Utils.IsYouLiBundler())) {
                YouLi.Trip.StripBlankLinkTargets();
            }

            YouLi.Trip.RefreshMenuAffix();

            YouLi.TripDates.Initialise();

            if (YouLi.Trip.InitialDate !== "") {
                if (YouLi.Trip.StyleName !== YouLi.Trip.StylesNameSalesPageDrSheri) {
                    YouLi.Trip.Program.GoToDate(YouLi.Trip.Program.ProgramSelectedDate);
                }
                YouLi.Trip.Itinerary.GoToDate(YouLi.Trip.InitialDate);
            }

            if (window.location.hash) {
                var section = window.location.hash.substring(1);

                if (section == "viewprofile") {
                    var urlParams = new URLSearchParams(window.location.search);
                    const viewInviteeId = urlParams.get("viewinvitee")
                    const inviteeId = viewInviteeId || $("#InviteeId").val();

                    if (inviteeId)
                        YouLi.Trip.ViewProfileForInvitee(inviteeId, true);
                }
                else {
                    if ($(".reservation-summary").length > 0)
                        YouLi.Trip.GoToSection(section, undefined, /*doScroll=*/ true);
                    else
                        YouLi.Trip.GoToSection(section);
                }
            }
            else if (YouLi.Trip.SkipToItinerary) {
                YouLi.Trip.GoToSection("itinerary");
            }

            if (YouLi.Trip.RespondedRecently) {

                // Scroll to the top of the content details when they have just responded
                $('html, body').animate({
                    scrollTop: $("#content-trip-paymentdetails .trip-details-main__inner").offset().top - YouLi.Trip.AffixTop()
                }, 1000, ShowRespondedYesRecentlyDialog);

            } else if (YouLi.Trip.CheckoutSuccessfulRecently) {

                // Scroll to the top of the payments list when they have just used checkout to register
                $('html, body').animate({
                    scrollTop: $("#ContentCostPaymentList").offset().top - YouLi.Trip.AffixTop()
                }, 1000, ShowRespondedYesRecentlyDialog);
            } else if (YouLi.Trip.GangPlaceholdersDialogOnLoad) {
                // show the gang placeholder details dialog immediately if required
                $('#GangPlaceholdersDialog').modal('show');
            }


            $(document).on("click", "#sendreceiptemailbutton", function () {
                YouLi.Common.SendPaymentReceipt($("#TripId").val(), $("#InviteeId").val());
            });

            $(document).on("click", ".content-trip-heading-title.allow-response", function () {
                $("#ResponseDialogYes").modal("show");
            });

            $(document).on("show.bs.modal", "#ResponseDialogYes", function (e) {

                // First, check if we need to redirect to checkout flow, based on the payment style (when the pricing mode is not Brochure Mode)
                if (YouLi.Trip.IsAnonymousAccess && YouLi.Trip.PricingMode != "estimated" && YouLi.Trip.PaymentStyle == "checkoutflowafter") {
                    window.location.href = YouLi.Trip.CheckoutFlowPageURL;
                    return e.preventDefault();
                }

                var numUnrespondedItineraryItems = $(".itinerary-accordion-item .response .check:not(.checked)").length;

                if (numUnrespondedItineraryItems == 0) {
                    $("#ResponseDialogYes .well.alert.outstanding-responses-list").addClass("hidden");
                }
                else {
                    $("#ResponseDialogYes .well.alert.outstanding-responses-list").removeClass("hidden");

                    $("#ResponseDialogYes .outstanding-responses-list ul").empty();
                    $(".itinerary-accordion-item .response .check:not(.checked)").each(function (item) {

                        var itineraryItemElement = $(this).closest(".itinerary-accordion-item");
                        var itineraryItemId = $(itineraryItemElement).data("id");

                        var itemToList = $.grep(YouLi.Trip.Itinerary.ItineraryItems, function (item) {
                            return item.ScheduleItemId == itineraryItemId;
                        });

                        if (itemToList.length != 0) {
                            var itemStartDate = moment(itemToList.StartDateTime);

                            $("#ResponseDialogYes .outstanding-responses-list ul").append("<li>" + itemToList[0].Name + " <span class='date'>" + itemStartDate.format('ddd DD MMM') + "</span>");
                        }
                    });
                }

            });

            $(document).on("hide.bs.modal", "#ResponseDialogYes", function () {
                // clear previous itinerary item selection
                $("#ResponseItineraryItemIncluded").val("");
            });

            $(document).on("click", '#ResponseDialogYes button[type="submit"]', function () {
                $("#ResponseDialogYes form").submit();
            });

            $(document).off('click', '.waitlisted').on('click', '.waitlisted', function () {
                $("#ResponseDialogNo").modal("show");
            });

            $(document)
                .off('shown.bs.modal', '#ResponseDialogNo')
                .on('shown.bs.modal', '#ResponseDialogNo', function () {
                    $(this).find('form').off('submit').on('submit', function (e) {
                        e.preventDefault();

                        const form = $(this);
                        const formData = new FormData(form[0]);

                        YouLi.Common.Post({
                            url: '/Trip/InviteeRespond',
                            params: formData,
                            contentType: false
                        }).then(function (result) {
                            const formSubmitBtn = $("form").find("input[type='submit']");

                            if (result.errors) {
                                YouLi.Common.UI.HideInputLoading(formSubmitBtn);
                                YouLi.Common.UI.HideLoading();
                                YouLi.Common.UI.ClearClientSideErrors();
                                YouLi.Common.UI.FormatClientSideErrors(result.errors);

                            } else {
                                YouLi.Common.UI.ClearClientSideErrors();
                                if (result.url) {
                                    window.location.href = result.url;
                                    if (result.reload)
                                        location.reload();
                                }
                            }
                        });
                    });
                });

            $(document).off("click", ".switch-invitee");
            $(document).on("click", ".switch-invitee", function () {

                const data = {
                    tripid: $("#TripId").val(),
                    inviteeid: $("#InviteeId").val(),
                    switchToInviteeId: $(this).data('inviteeid')
                };
                const updateLink = $(this).data('link');
                YouLi.Common.Post({
                    url: '/trip/InsertChangeProfileLog',
                    params: data,
                    errorCallback: function () {
                        window.location.assign(updateLink);
                    }
                }).then(function () {
                    window.location.assign(updateLink);
                });
            });

            $(document).off("click", ".set-meeting-slot-availability");
            $(document).on("click", ".set-meeting-slot-availability", function () {

                YouLi.Trip.SetMeetingBookingSlotAvailability(this);
            });

            $(document).off("click", ".view-profile-link");
            $(document).on("click", ".view-profile-link", function () {

                const inviteeId = $(this).data("profile-invitee-id");
                YouLi.Trip.ViewProfileForInvitee(inviteeId, true);
            });

            $(document).off("click", ".request-meeting");
            $(document).on("click", ".request-meeting", function () {

                YouLi.Trip.ShowRequestMeetingBookingDialog($(this));
            });

            $(document).off("click", "#MeetingBookingRequestDialog .do-send-request");
            $(document).on("click", "#MeetingBookingRequestDialog .do-send-request", function () {

                YouLi.Trip.RequestMeetingBooking();
            });

            $(document).off("click", ".decline-request");
            $(document).on("click", ".decline-request", function () {

                YouLi.Trip.ShowDeclineMeetingRequestDialog($(this));
            });

            $(document).off("click", "#DeclineMeetingRequestDialog .send-decline-request-messgae");
            $(document).on("click", "#DeclineMeetingRequestDialog .send-decline-request-messgae", function () {

                YouLi.Trip.DeclineMeetingRequest();
            });

            $(document).off("click", ".undo-declined-request");
            $(document).on("click", ".undo-declined-request", function () {

                YouLi.Trip.UndoDeclinedMeetingRequest($(this));
            });

            $(document).off("click", ".meeting-block-slots--selectable .slot:not(.booked)");
            $(document).on("click", ".meeting-block-slots--selectable .slot:not(.booked)", function () {

                YouLi.Trip.ShowScheduleMeetingBookingSlot($(this));
            });

            $(document).off("click", ".schedule-meeting");
            $(document).on("click", ".schedule-meeting", function () {

                YouLi.Trip.ScheduleMeetingBookingSlot($(this));
            });

            $(document).off("click", ".close-schedule");
            $(document).on("click", ".close-schedule", function () {

                YouLi.Trip.HideScheduleMeetingBookingSlot($(this));
            });

            $(document).off("click", ".meeting-block-slots--list--slot.booked .edit-booking");
            $(document).on("click", ".meeting-block-slots--list--slot.booked .edit-booking", function () {

                YouLi.Trip.ShowEditMeetingBookingSlot($(this));
            });

            // main menu functionality
            $(document).off("click", ".content-trip .content-tab");
            $(document).on("click", ".content-trip .content-tab", function () {
                var section = $(this).data("section");

                var triggerElement = $(this);
                var scrollTop = Math.max($("html").scrollTop(), $("body").scrollTop());        // NOTE: $("body").scrollTop returns the right value on safari, but returns the zero on other.  In reverse, $("html, body").scrollTop returns 0 in safari but the right value in others... argh!
                if (scrollTop > $('.content-trip-details-main').offset().top) {

                    $('html, body').animate({
                        scrollTop: $('.content-trip-details-main').offset().top
                    }, 'fast', function () {
                        YouLi.Trip.GoToSection(section, $(this), triggerElement.data("scroll"), triggerElement.data("scroll-override"));
                        $('.content-trip-details-menu.traveller ul.nav').affix('checkPosition');
                    });
                }
                else {

                    YouLi.Trip.GoToSection(section, $(this));
                    $('.content-trip-details-menu.traveller ul.nav').affix('checkPosition');
                }

            });

            $(document).on("click", ".content-trip-heading-details-location", function () {
                if (!$(".content-trip-heading-details-location").data('is-virtual')) {
                    $('html, body').animate({
                        scrollTop: $(".content-trip-details-location").offset().top
                    }, 1000);
                }

            });

            YouLi.Trip.SetupInviteeSectionMenu();

            // resources menu functionality
            $(".resources-section-links .content-list-tab:not(.disabled)").on("click touchstart", function () {
                var section = $(this).data("section");

                YouLi.Trip.GoToResourceSection(section);
            });


            $(".content-trip-response-footer-container").on("click", ".close-footer", function () {
                var tripId = $("#TripId").val();
                var in60Minutes = 1 / 24;
                Cookies.set(tripId + '-TripHideFooter', "true", { expires: in60Minutes });
                $(".content-trip-response-footer").addClass("hidden");

                YouLi.Trip.AdjustFooterForFloatingFooter();
            });

            function isImageBroken(image) {
                return image.naturalWidth === 0 || image.naturalHeight === 0 || image.complete === false;
            }

            $(document).on('change', '#NumberInGroup', function () {
                const data = {
                    tripid: $("#TripId").val(),
                    numberInGroup: $('#NumberInGroup').val(),
                    inviteeFullName: `${$('#ResponseFirstName').val()} ${$('#ResponseLastName').val()}`
                };

                YouLi.Common.Post({
                    url: '/trip/UpdateGangMembersSection',
                    params: data,
                }).then(function (response) {
                    if (response.success === false) {
                        YouLi.Common.UI.ShowStandardDialog("An error occurred.");
                    }
                    else {
                        $('#GangDetails').html(response.gangDetailsHtmlString);
                        $('#GangMemberDetails').html(response.gangMemberHtmlString);

                        $("#PrimaryInviteeGangMemberLabel").toggleClass("hidden", $(".gang-member-label").length == 1)

                        let $form = $('#AddEditTripUser');
                        $.validator.unobtrusive.parse($form);
                    }
                });
            });

            $(document).on('keypress', '[name="ResponseFirstName"], [name="ResponseLastName"]', function (e) {
                //64 is char '@'
                if (e.which === 64) {
                    e.preventDefault();
                }
            });

            YouLi.Trip.AdjustFooterForFloatingFooter(); // init

            // Set a timeout to update payments list if there are any in-progress payments
            YouLi.Trip.SetupUpdatePaymentsListTimer();

            $("#AddEditTripUser").off("dp.change", ".date-time-container .datepicker");
            $("#AddEditTripUser").on("dp.change", ".date-time-container .datepicker", function (e) {
                YouLi.Trip.UpdateDateTimeAnswer(this);
            });

            $("#AddEditTripUser").off("dp.change", ".date-time-container .timepicker");
            $("#AddEditTripUser").on("dp.change", ".date-time-container .timepicker", function (e) {
                YouLi.Trip.UpdateDateTimeAnswer(this);
            });

            /** The following is used to determine if the user is DRAGGING on the panel for FSB, in which case we don't want to trigger the click event */
            let isDragging = false;
            let startX, startY;
            const DRAG_THRESHOLD = 5; // pixels of movement before it counts as a drag

            $(document).off("mousedown", ".fsb-link").on("mousedown", ".fsb-link", function (e) {
                isDragging = false;
                startX = e.pageX;
                startY = e.pageY;
            });

            $(document).off("mousemove", ".fsb-link").on("mousemove", ".fsb-link", function (e) {
                if (startX !== undefined) {
                    const dx = Math.abs(e.pageX - startX);
                    const dy = Math.abs(e.pageY - startY);
                    if (dx > DRAG_THRESHOLD || dy > DRAG_THRESHOLD) {
                        isDragging = true;
                    }
                }
            });

            $(document).off("click", ".fsb-link").on("click", ".fsb-link", function (e) {

                // make sure it doesn't bubble if they click on the button
                e.stopPropagation();

                if (isDragging) return;   // bail out — it was a drag, not a click

                const $link = $(this);
                const data = {
                    tripId: $("#TripId").val()
                };

                YouLi.Common.Post({
                    url: '/Trip/SetFSBSessionData',
                    params: data,
                    errorCallback: () => {
                        YouLi.Common.UI.HideLoading();
                        YouLi.Common.UI.ShowStandardDialog("An error occurred when setting up session. Try again or contact your planner.");
                    }
                }).then((response) => {
                    YouLi.Common.UI.HideLoading();

                    if (!response.success) {
                        YouLi.Common.UI.ShowStandardDialog("An error occurred when setting up session. Try again or contact your planner.");
                    }
                    else {
                        window.location.href = $link.data("fsb-link");
                    }
                });
            });

            YouLi.Trip.SetupMapEvents();

            var forcePreventFooterUpdate = YouLi.Common.Utils.GetParameterFromURL("preventfooterupdate");
            if (!forcePreventFooterUpdate) {
                setTimeout(function () {
                    YouLi.Trip.UpdateResponseFooter(false, true);
                }, YouLi.Trip.FooterUpdateTimeout);
            }

            if (YouLi.Trip.ShowImageErrorReport) {

                const images = document.querySelectorAll('img');

                // Set up a load event listener, so that whenever an image successfully loods we can clear any broken image state off it
                images.forEach((img) => {
                    img.addEventListener("load", (event) => {
                        console.log("image with src " + event.target.src + " loaded");
                        event.target.classList.remove("broken-image");
                    });
                });

                // Update any editor images to skip cache (no need for signing policies on these bucket images)
                images.forEach((img) => {
                    if (img.src.indexOf("ylt-planner-editor-images.imgix.net")) {
                        img.src = img.src.replace("ylt-planner-editor-images.imgix.net", "ylt-planner-editorimages.s3.us-east-1.amazonaws.com");
                    }
                });

                // After a slight delay, loop through all the image elements on the page and check for any broken ones (they may also be subsequently fixed once they finished loading, if
                // that takes longer than 1 second)
                setTimeout(function () {
                    const brokenImageUrls = [];
                    // Iterate through the image elements and check for broken images, excluding lazy-loaded images
                    images.forEach((img) => {
                        if (!img.classList.contains("hidden") && (!img.hasAttribute('loading') || img.getAttribute('loading') !== 'lazy')) {
                            if (isImageBroken(img) && img.getAttribute('src')) {
                                console.log("Image with src " + img.src + " is broken");
                                img.classList.add("broken-image");
                                brokenImageUrls.push(img.getAttribute('src'));
                            }
                        }
                    });

                    // Display the array of broken image URLs in the console
                    //console.log('Broken Image URLs:', brokenImageUrls);

                    //if ($("img.broken-image").length > 0) 
                    const croppingNote = "<br><br>Note that in this view mode, cropping is not applied, click BACK TO TRIP to preview with cropping";
                    if (brokenImageUrls.length > 0)
                        YouLi.Common.UI.ShowStandardDialog(`There are images missing or about to expire from cache, please review the page for red boxes to see these.${croppingNote}`, "Check Images");
                    else
                        YouLi.Common.UI.ShowStandardDialog(`No images missing or about to expire from cache.${croppingNote}`, "Check Images", "OK", "success");
                }, 3000);
            }
            YouLi.Common.UI.Init();

            // Due to Stripe Payment redirect, we have to convert from param to section
            const stripeRedirectParam = "pageFlow";
            const pageSection = YouLi.Common.GetUrlParam(stripeRedirectParam);
            if (pageSection) {
                YouLi.Trip.GoToSection(pageSection);
                YouLi.Common.ClearUrlParams(stripeRedirectParam);
            }

            // setup email validation if required
            if (YouLi.Trip.EmailDomainValidationWhitelist.length > 0) {
                const allowedDomains = YouLi.Trip.EmailDomainValidationWhitelist.map(function (domain) {
                    return domain.trim().toLowerCase();
                });

                $.validator.addMethod('emailDomainValid', function (value, element) {
                    if (!value)
                        return true;

                    const emailParts = value.split('@');
                    if (emailParts.length !== 2)
                        return false;

                    const emailDomain = emailParts[1].trim().toLowerCase();

                    return allowedDomains.includes(emailDomain);

                }, YouLi.Trip.EmailDomainValidationErrorText);

                $('#ResponseEmail').rules('add', { emailDomainValid: true });
            }
        });

    }(YouLi.Trip ? YouLi.Trip : {}));
}(YouLi ? YouLi : {}));